import type { ICellRendererParams } from 'ag-grid-community';
import type { ColDefFactory, Column } from '.';
import { baseColumn } from './baseColumn';
import type { ToggleParams } from './toggle.types';

/** Toggle Switch
 * - supports values of 'Enabled' or true for "on" state, and 'Disabled' or false for "off" state. */
export const toggle: ColDefFactory<Column<ToggleParams>> = column => ({
  initialWidth: 85,
  ...baseColumn(column),
  headerClass: 'ag-center-aligned-cell',
  cellRenderer: 'toggle',
  valueGetter: params => {
    if (params.node == null || column.field == null) {
      return false;
    }
    const value = params.node.data?.[column.field];
    return value === 'Enabled' || value === true;
  },
  valueSetter: params => {
    if (params.node == null || column.field == null) {
      return false;
    }
    if (column.params?.valueSetter) {
      return column.params.valueSetter(params);
    }
    const getValue = params.data[column.field];
    const isBoolean = typeof getValue === 'boolean';
    if (isBoolean) {
      params.data[column.field] = params.newValue;
    } else {
      params.data[column.field] = params.newValue ? 'Enabled' : 'Disabled';
    }
    return true;
  },
  suppressHeaderMenuButton: column.suppressHeaderMenuButton ?? true,
  cellRendererParams: ({ data }: ICellRendererParams<any>) => {
    return {
      disabled: column.params?.isDisabled?.(data) ?? false,
      hidden: column.params?.isHidden?.(data) ?? false,
    };
  },
  // This is implicitly editable by clicking the toggle. Setting editable: true makes no sense here.
  editable: false,
});
